const BRAND_SUFFIX_RE = /\s\|\sJobcrawls$/i;

/** Trailing pagination fragment from +Head / +title (e.g. " (Page 2)"). */
const PAGE_SUFFIX_RE = /(\s+\((?:Page|Sivu|Sida)\s+\d+\))\s*$/;

function stripPageSuffix(title: string): { core: string; pageSuffix: string } {
  const m = title.match(PAGE_SUFFIX_RE);
  if (!m?.[1]) return { core: title, pageSuffix: '' };
  return { core: title.slice(0, -m[1].length).trimEnd(), pageSuffix: m[1] };
}

function truncatePlain(title: string, maxLength: number): string {
  if (title.length <= maxLength) return title;
  const truncated = title.substring(0, maxLength);
  const lastSpace = truncated.lastIndexOf(' ');
  return lastSpace > 50 ? truncated.substring(0, lastSpace).trim() : `${truncated.trim()}...`;
}

/**
 * Truncates SEO titles (~60 chars) without dropping the final `| Jobcrawls` brand segment
 * when present. Optional ` (Page N)` / ` (Sivu N)` / ` (Sida N)` suffix is preserved after truncation.
 */
export function truncateSeoTitle(title: string, maxLength: number = 60): string {
  const { core, pageSuffix } = stripPageSuffix(title);
  const budget = maxLength - pageSuffix.length;

  if (core.length <= budget) {
    return core + pageSuffix;
  }

  const brandMatch = core.match(BRAND_SUFFIX_RE);
  if (!brandMatch) {
    return truncatePlain(core, budget) + pageSuffix;
  }

  const brandSuffix = brandMatch[0];
  const head = core.slice(0, -brandSuffix.length);

  if (head.length + brandSuffix.length <= budget) {
    return core + pageSuffix;
  }

  const headBudget = budget - brandSuffix.length;
  if (headBudget < 10) {
    return `${(head + brandSuffix).substring(0, budget).trim()}${pageSuffix}`;
  }

  const truncatedHead = head.substring(0, headBudget);
  const lastSpace = truncatedHead.lastIndexOf(' ');
  const shortened =
    lastSpace > Math.max(8, Math.floor(headBudget * 0.55))
      ? truncatedHead.substring(0, lastSpace).trim()
      : truncatedHead.trim();

  return shortened + brandSuffix + pageSuffix;
}
